import React from 'react';
import { getIsJourneyReviewPanelEnabled } from 'modules/workflows/ducks';
import { useSelector } from 'react-redux';
import { NodeTile } from '../nodeTile';
// import { NodeSectionConfig } from './types';
import { StyledTilePanel, TileSections } from './NodeTilePanel.styled';
import { NodeTileSection } from './NodeTileSection';
// export type NodeTilePanelProps = {
//   /** List of all node types grouped in objects by tile section */
//   sections?: NodeSectionConfig[],
//   /**  Component to use as the tile */
//   TileComponent?: React.ReactNode,
//   /** FF check for SupportChatTest */
//   supportChatEnabled?: boolean,
//   /** Should show Review Needed messaging */
//   showReviewNeeded?: boolean,
//   /** Component to use as the for Review Needed messaging */
//   ReviewNeededComponent?: React.ReactNode,
// };

export const NODE_TILE_PANEL_TEST_ID = 'node-selector';

const NodeTilePanelCmp = (
  {
    sections = [],
    TileComponent = NodeTile,
    // FF check for SupportChatTest
    supportChatEnabled = false,
    showReviewNeeded = false,
    ReviewNeededComponent,
    hasAttachedJourneyConversion = false,
    AttachedJourneyConversion,
  } /*: NodeTilePanelProps */,
) => {
  const isJourneyReviewPanelEnabled = useSelector(getIsJourneyReviewPanelEnabled);
  return (
    <StyledTilePanel
      $supportChatTest={supportChatEnabled}
      data-test={NODE_TILE_PANEL_TEST_ID}
      data-testid={NODE_TILE_PANEL_TEST_ID}
    >
      {hasAttachedJourneyConversion && <AttachedJourneyConversion />}
      {!isJourneyReviewPanelEnabled && showReviewNeeded && <ReviewNeededComponent />}
      <TileSections>
        {sections.map((tileSection, index) =>
          tileSection.nodes && tileSection.nodes.length ? (
            <NodeTileSection
              key={`node-tile-section-${index}`}
              name={tileSection.name}
              nodes={tileSection.nodes}
              tileSection={tileSection.tileSection}
              TileComponent={TileComponent}
            />
          ) : null,
        )}
      </TileSections>
    </StyledTilePanel>
  );
};

export const NodeTilePanel = React.memo(NodeTilePanelCmp);

export default NodeTilePanel;
